<table style="width:100px;height:100px">
    <tr>
        <td>
            <mat-icon [matTooltip]="tooltip">image_not_supported</mat-icon>
        </td>
    </tr>
</table>
